import * as tslib_1 from "tslib";
import { AssetEvent } from "@awayjs/core";
import { DirectionalLight } from "@awayjs/scene";
import { CompositeMethodBase } from "./CompositeMethodBase";
import { ShadowHardMethod } from "./ShadowHardMethod";
/**
 * ShadowCompositeMethod is a shadow map method to apply cascade shadow mapping on materials.
 * Must be used with a DirectionalLight with a CascadeShadowMapper assigned to its shadowMapper property.
 *
 * @see away.lights.CascadeShadowMapper
 */
var ShadowCompositeMethod = (function (_super) {
    tslib_1.__extends(ShadowCompositeMethod, _super);
    /**
     * Creates a new ShadowCompositeMethod object.
     *
     * @param shadowMethodBase The shadow map sampling method used to sample individual cascades (fe: ShadowHardMethod, ShadowSoftMethod)
     */
    function ShadowCompositeMethod(baseMethod) {
        var _this = _super.call(this, baseMethod) || this;
        if (!(baseMethod.castingLight instanceof DirectionalLight))
            throw new Error("ShadowCompositeMethod is only compatible with DirectionalLight");
        baseMethod.castingLight.shadowMapper.addEventListener(AssetEvent.INVALIDATE, function (event) { return _this.onShadowMapperInvalidate(event); });
        return _this;
    }
    Object.defineProperty(ShadowCompositeMethod.prototype, "castingLight", {
        /**
         * The light casting the shadows.
         */
        get: function () {
            return this._baseMethod.castingLight;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ShadowCompositeMethod.prototype, "alpha", {
        /**
         *
         */
        get: function () {
            return this._baseMethod.alpha;
        },
        set: function (value) {
            this._baseMethod.alpha = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ShadowCompositeMethod.prototype, "epsilon", {
        /**
         *
         */
        get: function () {
            return this._baseMethod.epsilon;
        },
        set: function (value) {
            this._baseMethod.epsilon = value;
        },
        enumerable: true,
        configurable: true
    });
    ShadowCompositeMethod.prototype.createBaseMethod = function () {
        return new ShadowHardMethod(new DirectionalLight());
    };
    /**
     * Called when the shadow mappers cascade configuration changes.
     */
    ShadowCompositeMethod.prototype.onShadowMapperInvalidate = function (event) {
        this.invalidateShaderProgram();
    };
    return ShadowCompositeMethod;
}(CompositeMethodBase));
export { ShadowCompositeMethod };



// WEBPACK FOOTER //
// ../dist/lib/methods/ShadowCompositeMethod.js